export default __webpack_public_path__ + "img/2eb944aa808d7cd4d698daacb613725a.png";